import React, { Component } from 'react';
import { Layout } from 'antd';

import './content.css';

const { Content } = Layout;

class ContentWrapper extends Component {
    
    render() {
        return (
            <Content className='content'>
                { this.props.children }
            </Content>
        );
    }
}

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/App/components/content/content.js